import React from 'react';
import { FragmentParagraphBasicHtmlFragment } from '@/utils/drupal-api/__generated__/graphql';
import clsx from 'clsx';

import styles from './basic_html.module.scss';
import paragraphStyles from './paragraph.module.scss';

export type BasicHtmlProps = {
  data: FragmentParagraphBasicHtmlFragment;
  className?: string;
  id?: string;
};

export const BasicHtml: React.FC<BasicHtmlProps> = ({
  data,
  className,
  id,
}) => {
  return data.html?.processed ? (
    <div
      id={id}
      className={clsx(
        paragraphStyles.paragraph,
        styles.paragraphBasicHTML,
        className,
        'wysiwyg',
        'paragraph',
        'paragraph-basic-html'
      )}
      dangerouslySetInnerHTML={{ __html: data.html?.processed }}
    />
  ) : (
    <></>
  );
};
